var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g(_vm._b({staticClass:"u-button",class:[_vm.type, { 'is-loading': _vm.loading }]},'button',_vm.$attrs,false),_vm.$listeners),[_vm._m(0),_vm._t("default")],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"loader-container"},[_c('span',{staticClass:"loader"})])
}]

export { render, staticRenderFns }